/* eslint class-methods-use-this: 0 */
import request from 'superagent';
import { API } from './Constants';

class Client {
  /**
   *
   * @description Requests data from the TTP translation API.
   * @param {function} cb - Callback function to invoke once response is returned from the service
   */
  fetchContent(cb) {
    // eslint-disable-next-line operator-linebreak
    const locale =
      window.tesla && window.tesla.App ? window.tesla.App.locale : 'en_US';
    request
      .get(`/trips-api/strings?locale=${locale}`)
      .set('Content-Type', 'application/json')
      .end(cb);
  }

  /**
   * @description Requests localized content from the TTP translation API.
   *
   * @param {string} modelCode
   * @param {string} locale
   * @param {function} cb
   */
  fetchOptions(modelCode, locale = 'en_US', lastDataUpdate, cb) {
    // FND-1277 Other Europe exception.
    const updatedLocale = locale === 'en_EU' ? 'en_IE' : locale;

    request
      .get(
        `/cua-api/option/specs?model=${modelCode}&locale=${updatedLocale}&date=${lastDataUpdate}`,
      )
      .set('Content-Type', 'application/json')
      .end(cb);
  }

  /**
   * @description Requests data from the routing API
   *
   * @param {Object} params - Required parameters for the routing API
   * @param {Object} params.route - Details about the requested route
   * @param {string} params.route.origin - comma separated (lat,lng) of users origin
   * @param {string} params.route.destination - Comma separated (lat,lng) of users destination
   * @param {Array} params.stopovers - Collection of lat,lng pairs in between origin & destination
   * @param {Object} params.route - Details about the vehicle used on the trip
   * @param {string} params.route.model - Vehicle model code ie; "MS_2017_100D"
   * @param {function} cb - Callback function to invoke once response is returned from the service
   *
   * @return {Object} response from routing API
   */
  fetchDirections(params, cb) {
    const body = {
      model: params.vehicle.model,
      origin: params.route.origin,
      destination: params.route.destination,
      stopovers: params.route.stopovers,
    };

    request
      .post(API.directions.path)
      .send(body)
      .set('accept', 'application/json')
      .end(cb);
  }

  /**
   * @description Requests Superchargers from the locations API
   *
   * @param {function} cb - Callback function to invoke once response is returned from the service
   *
   * @return {Object} response from locations API
   */
  fetchAllSuperchargers(cb) {
    request
      .get(API.allSuperchargers.path)
      .set('Content-Type', 'application/json')
      .end(cb);
  }

  /**
   * @description Requests chargers details from the locations API
   *
   * @param {string} id - Unique identifier for a Supercharger or destination charger
   * @param {function} cb - Callback function to invoke once response is returned from the service
   *
   * @return {Object} response from locations API
   */
  fetchChargerDetails(id, cb) {
    const cid = id.match(/[a-z]/i) ? id : Number(id);
    request.get(`${API.chargerDetails}?id=${cid}`).end(cb);
  }

  /**
   * @description Requests destination chargers from the locations API
   *
   * @param {Object} params - Required parameters for the locations API
   * @param {integer} params.distance - Search radius in desired @unitOfDistance
   * @param {Object} params.location - Details of where to search on the World map
   * @param {float} params.location.lat - Latitude of where to search
   * @param {float} params.location.lon - Longitude of where to search
   * @param {string} params.unitOfDistance - (MI|KM)
   * @param {function} cb - Callback function to invoke once response is returned from the service
   *
   * @return {Object} response from locations API
   */
  fetchDestinationChargers(params, cb) {
    request
      .post(API.destinationChargers.path)
      .send(params)
      .set('Content-Type', 'application/json')
      .end(cb);
  }

  /**
   * @description Requests fuel efficiency data from the gas savings / incentives API
   *
   * @param {string} countryCode - Country code of where to get incentive data
   * @param {string} modelCode - Vehicle model code
   * @param {function} cb - Callback function to invoke once response is returned from the service
   *
   * @return {Object} response from locations API
   */
  loadFuelEfficiency(countryCode, modelCode, cb) {
    request
      .get(
        `${
          API.gasSavings
        }?market=${countryCode}&incentiveType=fuel&variant=${modelCode}`,
      )
      .end(cb);
  }
}

export default new Client();
